import React, { useState } from "react";
import { CgChevronLeft } from "react-icons/cg";
import Paypal from "../../utils/Icons/Paypal.svg";
import StripeSVG from "../../utils/Icons/Stripe.svg";
import { PayPal } from "./PayPal";
import { Stripe } from "./Stripe";
import { Deposit } from "./Deposit";

export const PaymentMethods = ({ handleShowPayment }) => {
  const [isToggled, setIsToggled] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("PayPal");
  const [showPayPal, setShowPayPal] = useState(false);
  const [switchDeposit, setSwitchDeposit] = useState(false)

  const handleToggle = () => {

    setIsToggled(!isToggled);
    setSwitchDeposit(prev => !prev)
  };

  const handleSelectMethod = (method) => {
    setSelectedMethod(method);
  };

  return (
    <div className="w-full lg:px-6 lg:py-4 overflow-x-scroll lg:w-[90%] xl:w-full hidescroll">
      <div className="md:flex items-center justify-between">
        <div>
          <div
            onClick={handleShowPayment}
            className="cursor-pointer flex items-center space-x-2"
          >
            <CgChevronLeft /> <button>Payouts History</button>
          </div>
          <h1 className="text-[28px] md:text-[32px]">Payment Methods</h1>
          <p>Select a default payment method.</p>
        </div>
        <div className="my-2 flex items-center space-x-2">
          <p>Switch to Deposit</p>
          <div
            onClick={handleToggle}
            className={`cursor-pointer w-12 rounded-full ${
              isToggled ? "bg-[#46BA58]" : "bg-[#5B5B5B]"
            } p-[2px] `}
          >
            <div
              className={`w-5 h-5 rounded-full bg-white dark:bg-[#1c1c1c] ${
                isToggled ? "translate-x-[22px]" : ""
              }`}
            />
          </div>
        </div>
      </div>

      {switchDeposit ?
      <Deposit/> : <>
      <div className="my-4 md:flex space-y-4 md:space-y-0 items-center md:space-x-4">
        <div
          onClick={() => handleSelectMethod("PayPal")}
          className={`flex w-full justify-between space-x-4 border px-6 py-5 rounded-xl cursor-pointer ${
            selectedMethod === "PayPal" ? "dark:border-white border-gray-600" : "dark:border-gray-600"
          }`}
        >
          <div>
            <p className="text-2xl">PayPal</p>
            <p className="opacity-60">
              Receive payments right into your PayPal account
            </p>
          </div>
          <img src={Paypal} alt="PayPal" />
        </div>
        <div
          onClick={() => handleSelectMethod("Stripe")}
          className={`flex w-full justify-between space-x-4 border px-6 py-5 rounded-xl cursor-pointer ${
            selectedMethod === "Stripe" ? "border-gray-600 dark:border-white" : "dark:border-gray-600"
          }`}
        >
          <div>
            <p className="text-2xl">Connect with Stripe</p>
            <p className="opacity-60">
              Receive payments through your Stripe account
            </p>
          </div>
          <img className="mix-blend-overlay bg-gray-400 w-8 h-8 rounded" src={StripeSVG} alt="Stripe" />
        </div>
      </div>
      
      {selectedMethod === "PayPal" ? (
        <PayPal
          Paypal={Paypal}
          showPayPal={showPayPal}
          setShowPayPal={setShowPayPal}
        />
      ) : selectedMethod === "Stripe" ? (
        <Stripe
          Stripe={StripeSVG}
        />
      ) : null}
      <button
        className={
          showPayPal
            ? "bg-[#1c1c1c] text-white dark:bg-white dark:text-[#1c1c1c] my-4 px-4 py-3 rounded-xl "
            : "hidden"
        }
      >
        Save Changes
      </button>
      </> }
    </div>
  );
};
